import { SvgIcon, SxProps } from "@mui/material";
import CircleCheckSvg from "jsx:../../../Images/Icons/FontAwesome/light/circle-check.svg";

export function CircleCheckLightIcon(props: SxProps) {
    return <SvgIcon component={CircleCheckSvg} inheritViewBox sx={props} />;
}
